import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import Header from "../components/Header";
import NotificationSettingsList from "../components/NotificationSettingsList";
import styles from "./NotificationSettingsPage.module.css";
import { useTranslation } from "react-i18next";

export function NotificationSettingsPage({ selectedView }) {
  const {t} = useTranslation();
  const history = useHistory();

  const iboEventsItems = [
    {
      label: t("I'm added for Eagle qualification"),
      on: true,
    },
  ];
  const iboCalendarItems = [
    {
      label: t("Organizational meetings are created"),
      on: true,
    },
    {
      label: t("Organizational meetings are updated"),
      on: false,
    },
  ];

  const diamondEventsItems = [
    {
      label: t("I'm added for Eagle qualification"),
      on: true,
    },
  ];

  const diamondCalendarItems = [
    {
      label: t("Shareable downline meetings are created"),
      on: true,
    },
    {
      label: t("Shareable downline meetings are updated"),
      on: false,
    },
    {
      label: t("Organizational meetings are shared"),
      on: false,
    },
    {
      label: t("Organizational meetings are shared by other Diamonds are updated"),
      on: false,
    },
  ];

  const getItemsForView = () => {
    if (selectedView === "IBO") {
      return {
        events: iboEventsItems,
        calendar: iboCalendarItems,
      };
    } else if (selectedView === "Diamond") {
      return {
        events: diamondEventsItems,
        calendar: diamondCalendarItems,
      };
    }
  };

  const { events, calendar } = getItemsForView();

  const handleHeaderBackClick = () => {
    history.push("/");
  };

  return (
    <div className={styles.container}>
      <Header header={t("Settings")} onClick={handleHeaderBackClick} />
      <div className="content">
        <NotificationSettingsList
          items={events}
          header="Events"
          view={selectedView}
        />
        <NotificationSettingsList
          items={calendar}
          header="Function Calendar"
          view={selectedView}
        />
      </div>
    </div>
  );
}

NotificationSettingsPage.propTypes = {
  selectedView: PropTypes.oneOf(["IBO", "Diamond"]).isRequired,
};
